import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "../components/AppHeader";
import ProgressDots from "../components/ProgressDots";
import ProductImage from "../components/ProductImage";
import PrimaryButton from "../components/PrimaryButton";
import { t } from "../services/i18n";
import { track } from "../services/analytics";

export default function HandPositionPage() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("hand_position_viewed");
  }, []);

  return (
    <>
      <AppHeader title={t("handPosition.title")} backTo="/getting-started" />
      <div className="page">
        <ProgressDots total={4} current={1} />
        <h2 className="h1">{t("handPosition.heading")}</h2>
        <p className="sub">{t("handPosition.body")}</p>

        <ProductImage />

        <div className="info-banner">
          <strong>{t("handPosition.tipTitle")}</strong>
          {t("handPosition.tip")}
        </div>
        <div className="mt-auto mt-24">
          <PrimaryButton label={t("common.next")} onClick={() => navigate("/modes")} />
        </div>
      </div>
    </>
  );
}
